// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._36zlz{margin:0 auto;max-width:1112px;max-width:69.5rem;padding:1.5rem 0 4rem}@media(max-width:1439px){._36zlz{padding:1.5rem 5.875rem 4rem}}@media(max-width:1023px){._36zlz{padding:1rem 0 4rem}}@media(max-width:767px){._36zlz{padding-top:0}}._3OPUj{margin-bottom:2rem;position:relative}@media(max-width:1439px){._3OPUj{margin-left:-2.875rem}}@media(max-width:1023px){._3OPUj{margin-left:1.5rem}}@media(max-width:767px){._2GLEH{margin-left:1rem;position:absolute;top:4rem;z-index:1}}@media(max-width:767px){._1qLDc{margin-left:1rem;margin-top:1rem}}._1b-ip{background-color:rgba(247,248,248,.2);padding:.5rem;border-radius:50%;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;cursor:pointer}._1b-ip path[fill]{fill:#231815}._1b-ip h5{margin-left:.75rem}._2eOZP{display:-ms-flexbox;display:flex;margin:0 auto;-ms-flex-pack:center;justify-content:center}@media(max-width:1439px){._2eOZP{-ms-flex-direction:column;flex-direction:column}}._2rkNR{-ms-flex:1 1;flex:1 1}@media(max-width:1023px){._2rkNR{padding-left:5.875rem;padding-right:5.875rem}}@media(max-width:767px){._2rkNR{padding-left:1rem;padding-right:1rem}}._3Afe-{-ms-flex:1 1;flex:1 1;margin-bottom:2rem;height:472px;height:29.5rem}@media(max-width:1439px){._3Afe-{display:none}}._2lvZJ+._2lvZJ{margin-top:1.5rem}.mPQ_c{margin-top:2.5rem}._2Fx28{display:none}@media(max-width:767px){._2Fx28{display:block}}@media(max-width:767px){._3nFN0{display:none}}._1nc9A{position:relative;top:-72px;top:-4.5rem}@media(max-width:767px){._1nc9A{top:-3rem}}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "_36zlz",
	"header": "_3OPUj",
	"avatarHeader": "_2GLEH",
	"videoHeader": "_1qLDc",
	"backIconWrapper": "_1b-ip",
	"body": "_2eOZP",
	"content": "_2rkNR",
	"player": "_3Afe-",
	"contentList": "_2lvZJ",
	"seeMoreButton": "mPQ_c",
	"contentMobileList": "_2Fx28",
	"contentDesktopList": "_3nFN0",
	"sentinel": "_1nc9A"
};
module.exports = exports;
